import { useState } from 'react';
import PublishTemplate from '../DialogComponent/PublishTemplate';
import SelectContacts from '../DialogComponent/SelectContacts';
import SelectGroupTeam from '../DialogComponent/SelectGroupTeam';

export const StartPage = () => {
  const [publishTemplate, setPublishTemplate] = useState(false);
  const [selectContact, setSelectContact] = useState(false);
  const [createGroupTeam, setCreateGroupTeam] = useState(false);
  const [createGroupTeamTool, setCreateGroupTeamTool] = useState(false);

  return (
    <div className="w-full h-full p-4">
      Temporärer Bereich: Modale
      <div className="flex flex-col gap-2 items-start">
        <button
          className="cursor-pointer"
          onClick={() => setPublishTemplate(true)}
        >
          Vorlage veröffentlichen
        </button>
        <button
          className="cursor-pointer"
          onClick={() => setSelectContact(true)}
        >
          Kontakt auswählen
        </button>
        <button
          className="cursor-pointer"
          onClick={() => setCreateGroupTeam(true)}
        >
          Gruppe/Team anlegen
        </button>
        <button
          className="cursor-pointer"
          onClick={() => setCreateGroupTeamTool(true)}
        >
          Gruppe/Team mit Tools anlegen
        </button>
      </div>
      <PublishTemplate
        open={publishTemplate}
        onClose={() => setPublishTemplate(false)}
      />
      <SelectContacts
        open={selectContact}
        onClose={() => setSelectContact(false)}
      />
      <SelectGroupTeam
        open={createGroupTeam}
        onClose={() => setCreateGroupTeam(false)}
      />
      <SelectGroupTeam
        toolOption
        open={createGroupTeamTool}
        onClose={() => setCreateGroupTeamTool(false)}
      />
    </div>
  );
};
